import { useContext, useEffect, useState } from 'react';
// import { useLocation } from "react-router-dom";
// import customBreadcrump from "@helper/customBreadcrump";
import { UserContext } from '@/context/createContext';
import ModalAddContent from './ModalAddContent';
import AddCustomer from '../modules/customers/AddCustomer';
import ModalInviteAgent from '../modules/agents/ModalInviteAgent';
import ModalSearchContent from './ModalSearchContent';
import { useLocation } from 'react-router-dom';
import customBreadcrump from '@/helper/customBreadcrump';

export default function Header() {
  const {
    user: { profilePicture, fullname },
  } = useContext(UserContext);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [openSheet, setOpenSheet] = useState(null);

  const [openSearch, setOpenSearch] = useState(false);

  const { pathname } = useLocation();
  const [today, setToday] = useState('');
  const [breadcrump, setBreadcrump] = useState();

  useEffect(() => {
    setToday(new Date().toLocaleString('fa-IR', { dateStyle: 'medium' }));
    setBreadcrump(customBreadcrump(pathname));
  }, [pathname]);

  return (
    <>
      <div className="w-full max-sm:rounded-none max-Width md:pt-5 space-y-2">
        <div className="flex flex-row items-center justify-between font-normal text-blackFont-800">
          <div className="flex flex-row items-center">
            <p className="text-base max-sm:text-xs">{today}</p>
            <span className="w-2 h-2 max-sm:w-1 max-sm:h-1 rounded-full bg-blackFont-800 mx-5 max-sm:mx-1.5"></span>
            <p className="text-sm max-sm:text-[10px]">{breadcrump?.title}</p>
            {breadcrump?.sub && (
              <>
                <span className="px-2 max-sm:px-1 text-blackFont-800">
                  <img src="/svg/arrow-left.svg" alt="arrow-left" className="w-fit h-fit" />
                </span>
                <p className="text-sm max-sm:text-[10px]">{breadcrump.sub}</p>
              </>
            )}
            {breadcrump?.sub2 && (
              <>
                <span className="px-2 max-sm:hidden">
                  <img src="/svg/arrow-left.svg" alt="arrow-left" className="w-fit h-fit" />
                </span>
                <p className="text-sm max-sm:text-xs max-sm:hidden">{breadcrump.sub2}</p>
              </>
            )}
          </div>
          <div className="flex flex-row items-center gap-6 text-blackFont-800 max-sm:gap-4">
            <a
              href="tel:0215100"
              data-tooltip-id="my-tooltip"
              data-tooltip-content={window.innerWidth > 640 ? 'شماره تماس : 0215100' : null}
              data-tooltip-place="right"
              className="flex flex-row items-center gap-1.5 cursor-pointer"
            >
              <span className="max-sm:hidden">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.9676 18.3298C21.9676 18.6898 21.8876 19.0598 21.7176 19.4198C21.5476 19.7798 21.3276 20.1198 21.0376 20.4398C20.5476 20.9798 20.0076 21.3698 19.3976 21.6198C18.7976 21.8698 18.1476 21.9998 17.4476 21.9998C16.4276 21.9998 15.3376 21.7598 14.1876 21.2698C13.0376 20.7798 11.8876 20.1198 10.7476 19.2898C9.59756 18.4498 8.50756 17.5198 7.46756 16.4898C6.43756 15.4498 5.50756 14.3598 4.67756 13.2198C3.85756 12.0798 3.19756 10.9398 2.71756 9.80985C2.23756 8.66985 1.99756 7.57985 1.99756 6.53985C1.99756 5.85985 2.11756 5.20985 2.35756 4.60985C2.59756 3.99985 2.97756 3.43985 3.50756 2.93985C4.14756 2.30985 4.84756 1.99985 5.58756 1.99985C5.86756 1.99985 6.14756 2.05985 6.39756 2.17985C6.65756 2.29985 6.88756 2.47985 7.06756 2.73985L9.38756 6.00985C9.56756 6.25985 9.69756 6.48985 9.78756 6.70985C9.87756 6.91985 9.92756 7.12985 9.92756 7.31985C9.92756 7.55985 9.85756 7.79985 9.71756 8.02985C9.58756 8.25985 9.39756 8.49985 9.15756 8.73985L8.39756 9.52985C8.28756 9.63985 8.23756 9.76985 8.23756 9.92985C8.23756 10.0098 8.24756 10.0798 8.26756 10.1598C8.29756 10.2398 8.32756 10.2998 8.34756 10.3598C8.52756 10.6898 8.83756 11.1198 9.27756 11.6398C9.72756 12.1598 10.2076 12.6898 10.7276 13.2198C11.2676 13.7498 11.7876 14.2398 12.3176 14.6898C12.8376 15.1298 13.2676 15.4298 13.6076 15.6098C13.6576 15.6298 13.7176 15.6598 13.7876 15.6898C13.8676 15.7198 13.9476 15.7298 14.0376 15.7298C14.2076 15.7298 14.3376 15.6698 14.4476 15.5598L15.2076 14.8098C15.4576 14.5598 15.6976 14.3698 15.9276 14.2498C16.1576 14.1098 16.3876 14.0398 16.6376 14.0398C16.8276 14.0398 17.0276 14.0798 17.2476 14.1698C17.4676 14.2598 17.6976 14.3898 17.9476 14.5598L21.2576 16.9098C21.5176 17.0898 21.6976 17.2998 21.8076 17.5498C21.9076 17.7998 21.9676 18.0498 21.9676 18.3298Z"
                    stroke="#242424"
                    stroke-miterlimit="10"
                  />
                  <path
                    d="M18.4961 8.99994C18.4961 8.39994 18.0261 7.47994 17.3261 6.72994C16.6861 6.03994 15.8361 5.49994 14.9961 5.49994"
                    stroke="#242424"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21.9961 8.99985C21.9961 5.12985 18.8661 1.99985 14.9961 1.99985"
                    stroke="#242424"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
              <span className="sm:hidden">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M22 9C22 5.13 18.87 2 15 2"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <p className="text-sm max-sm:hidden">پشتیبانی</p>
            </a>
          </div>
          {/* <a
          href="tel:02154725110"
          data-tooltip-id="my-tooltip"
          data-tooltip-content={window.innerWidth > 640 ? 'شماره تماس : 02154725110' : null}
          data-tooltip-place="bottom"
          className="flex flex-row items-center gap-1.5 cursor-pointer"
        >
          <span className="max-sm:hidden">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.9676 18.3298C21.9676 18.6898 21.8876 19.0598 21.7176 19.4198C21.5476 19.7798 21.3276 20.1198 21.0376 20.4398C20.5476 20.9798 20.0076 21.3698 19.3976 21.6198C18.7976 21.8698 18.1476 21.9998 17.4476 21.9998C16.4276 21.9998 15.3376 21.7598 14.1876 21.2698C13.0376 20.7798 11.8876 20.1198 10.7476 19.2898C9.59756 18.4498 8.50756 17.5198 7.46756 16.4898C6.43756 15.4498 5.50756 14.3598 4.67756 13.2198C3.85756 12.0798 3.19756 10.9398 2.71756 9.80985C2.23756 8.66985 1.99756 7.57985 1.99756 6.53985C1.99756 5.85985 2.11756 5.20985 2.35756 4.60985C2.59756 3.99985 2.97756 3.43985 3.50756 2.93985C4.14756 2.30985 4.84756 1.99985 5.58756 1.99985C5.86756 1.99985 6.14756 2.05985 6.39756 2.17985C6.65756 2.29985 6.88756 2.47985 7.06756 2.73985L9.38756 6.00985C9.56756 6.25985 9.69756 6.48985 9.78756 6.70985C9.87756 6.91985 9.92756 7.12985 9.92756 7.31985C9.92756 7.55985 9.85756 7.79985 9.71756 8.02985C9.58756 8.25985 9.39756 8.49985 9.15756 8.73985L8.39756 9.52985C8.28756 9.63985 8.23756 9.76985 8.23756 9.92985C8.23756 10.0098 8.24756 10.0798 8.26756 10.1598C8.29756 10.2398 8.32756 10.2998 8.34756 10.3598C8.52756 10.6898 8.83756 11.1198 9.27756 11.6398C9.72756 12.1598 10.2076 12.6898 10.7276 13.2198C11.2676 13.7498 11.7876 14.2398 12.3176 14.6898C12.8376 15.1298 13.2676 15.4298 13.6076 15.6098C13.6576 15.6298 13.7176 15.6598 13.7876 15.6898C13.8676 15.7198 13.9476 15.7298 14.0376 15.7298C14.2076 15.7298 14.3376 15.6698 14.4476 15.5598L15.2076 14.8098C15.4576 14.5598 15.6976 14.3698 15.9276 14.2498C16.1576 14.1098 16.3876 14.0398 16.6376 14.0398C16.8276 14.0398 17.0276 14.0798 17.2476 14.1698C17.4676 14.2598 17.6976 14.3898 17.9476 14.5598L21.2576 16.9098C21.5176 17.0898 21.6976 17.2998 21.8076 17.5498C21.9076 17.7998 21.9676 18.0498 21.9676 18.3298Z"
                stroke="#242424"
                stroke-miterlimit="10"
              />
              <path
                d="M18.4961 8.99994C18.4961 8.39994 18.0261 7.47994 17.3261 6.72994C16.6861 6.03994 15.8361 5.49994 14.9961 5.49994"
                stroke="#242424"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M21.9961 8.99985C21.9961 5.12985 18.8661 1.99985 14.9961 1.99985"
                stroke="#242424"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
          <span className="sm:hidden">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.97 18.33C21.97 18.69 21.89 19.06 21.72 19.42C21.55 19.78 21.33 20.12 21.04 20.44C20.55 20.98 20.01 21.37 19.4 21.62C18.8 21.87 18.15 22 17.45 22C16.43 22 15.34 21.76 14.19 21.27C13.04 20.78 11.89 20.12 10.75 19.29C9.6 18.45 8.51 17.52 7.47 16.49C6.44 15.45 5.51 14.36 4.68 13.22C3.86 12.08 3.2 10.94 2.72 9.81C2.24 8.67 2 7.58 2 6.54C2 5.86 2.12 5.21 2.36 4.61C2.6 4 2.98 3.44 3.51 2.94C4.15 2.31 4.85 2 5.59 2C5.87 2 6.15 2.06 6.4 2.18C6.66 2.3 6.89 2.48 7.07 2.74L9.39 6.01C9.57 6.26 9.7 6.49 9.79 6.71C9.88 6.92 9.93 7.13 9.93 7.32C9.93 7.56 9.86 7.8 9.72 8.03C9.59 8.26 9.4 8.5 9.16 8.74L8.4 9.53C8.29 9.64 8.24 9.77 8.24 9.93C8.24 10.01 8.25 10.08 8.27 10.16C8.3 10.24 8.33 10.3 8.35 10.36C8.53 10.69 8.84 11.12 9.28 11.64C9.73 12.16 10.21 12.69 10.73 13.22C11.27 13.75 11.79 14.24 12.32 14.69C12.84 15.13 13.27 15.43 13.61 15.61C13.66 15.63 13.72 15.66 13.79 15.69C13.87 15.72 13.95 15.73 14.04 15.73C14.21 15.73 14.34 15.67 14.45 15.56L15.21 14.81C15.46 14.56 15.7 14.37 15.93 14.25C16.16 14.11 16.39 14.04 16.64 14.04C16.83 14.04 17.03 14.08 17.25 14.17C17.47 14.26 17.7 14.39 17.95 14.56L21.26 16.91C21.52 17.09 21.7 17.3 21.81 17.55C21.91 17.8 21.97 18.05 21.97 18.33Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
              />
              <path
                d="M18.5 9C18.5 8.4 18.03 7.48 17.33 6.73C16.69 6.04 15.84 5.5 15 5.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M22 9C22 5.13 18.87 2 15 2"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <p className="text-sm max-sm:hidden">پشتیبانی</p>
        </a>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setIsOpenModal(true)}
            className="text-sm font-medium text-primary px-4 py-2 rounded-lg flex items-center gap-1 border-1 border-primary"
          >
            <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9.19141 9.75H4.69141V8.25H9.19141V3.75H10.6914V8.25H15.1914V9.75H10.6914V14.25H9.19141V9.75Z"
                fill="#2563EB"
              />
            </svg>
            افزودن جدید
          </button>
          <div
            onClick={() => setOpenSearch(true)}
            className="flex items-center gap-1.5 py-1.5 px-4 w-72 text-text-normal border-1 border-light-grey rounded-lg cursor-pointer"
          >
            <span>
              <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.4434 21C17.6901 21 21.9434 16.7467 21.9434 11.5C21.9434 6.25329 17.6901 2 12.4434 2C7.19665 2 2.94336 6.25329 2.94336 11.5C2.94336 16.7467 7.19665 21 12.4434 21Z"
                  stroke="#616161"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M22.9434 22L20.9434 20"
                  stroke="#616161"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <p className="text-sm text-text-normal">جستجو</p>
            <input type="text" className="w-full" placeholder="جستجو" />
          </div>
        </div>
        <div className="flex items-center gap-2 px-3 cursor-pointer">
          <img
            src={profilePicture ? `${import.meta.env.VITE_API_URL}/${profilePicture}` : '/svg/user.svg'}
            alt="profile"
            className="h-9 w-9 rounded-full outline-2 outline-primary outline"
          />
          <p className="text-sm">{fullname}</p>
          <span>
            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M1 1.53345L3.94167 4.46678L6.88333 1.53345"
                stroke="#242424"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div> */}
        </div>
        <div className="w-full text-center flex items-center justify-center text-error py-1 md:hidden">
          <p className="text-xs md:text-sm">" این یک نسخه نمونه کار است و داده‌ها فیک و غیرقابل تغییر هستند. "</p>
        </div>
      </div>
      {isOpenModal && (
        <ModalAddContent title="نوع محتوا خود را مشخص کنید" onOpenChange={setIsOpenModal} setOpenSheet={setOpenSheet} />
      )}
      {openSheet == 'customer' && <AddCustomer setShowModalAdd={setOpenSheet} />}
      {openSheet == 'agent' && <ModalInviteAgent isOpenRequest={openSheet} setIsOpenRequest={setOpenSheet} />}
      {openSearch && <ModalSearchContent onOpenChange={setOpenSearch} />}
    </>
  );
}
